import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";
import toast from "components/ui/toast/Toast";
import { useDeleteBidWinTheme } from "lib/hooks/api/bid/win_themes/useDeleteBidWinTheme";

type Props = {
  bidId: string;
  themeId: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
};

export function DeleteWinThemeModal({ bidId, themeId, isOpen, onOpenChange, onSuccess }: Props) {
  const { mutate: deleteWinTheme, isLoading } = useDeleteBidWinTheme({ bidId });

  const handleDelete = () => {
    deleteWinTheme(
      { id: themeId },
      {
        onSuccess: () => {
          toast.success("Win theme deleted successfully");
          onSuccess();
        },
        onError: () => toast.error("Failed to delete win theme"),
      },
    );
  };

  return (
    <Modal open={isOpen} padding={24} onOpenChange={onOpenChange}>
      <Flex flexDirection="column" gap={16}>
        <Text h3 bold>
          Delete Win Theme
        </Text>
        <Text>Are you sure you want to delete this win theme? This action cannot be undone.</Text>
        <Flex gap={16} justifyContent="flex-end">
          <Button buttonType="secondary" onClick={() => onOpenChange(false)} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            buttonStyle="destructive"
            onClick={handleDelete}
            loading={isLoading}
            aria-label="Delete win theme submit"
          >
            Delete Win Theme
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
